import script from "./HealthCategories.vue?vue&type=script&lang=js&setup=true"
export * from "./HealthCategories.vue?vue&type=script&lang=js&setup=true"

import "./HealthCategories.vue?vue&type=style&index=0&id=55dc714a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55dc714a"]])

export default __exports__